import React, { Suspense, lazy } from 'react'
import { type LottieComponentProps } from 'lottie-react';
import { useQuery } from 'react-query';

const LazyLottieComponent = lazy(() => import('lottie-react'));

interface LottieProps<T extends Record<string, unknown>> {
  getAnimationData: () => Promise<T>;
  id: string;
}

export function LazyLottie<T extends Record<string, unknown>>({
  getAnimationData,
  id,
  ref,
  ...props
}: LottieProps<T> & Omit<LottieComponentProps, 'animationData'>) {
  const { data } = useQuery({
    queryKey: [id],
    queryFn: async () => {
      void import('lottie-react'); // Trigger the library lazy load even if the animationData is not ready
      return getAnimationData();
    },
    enabled: typeof window !== 'undefined'
  });

  if (!data) return <div />;

  return (
    <Suspense fallback={<div>{'...Loading'}</div>}>
      <LazyLottieComponent animationData={data} {...props} />
    </Suspense>
  );
}